<template>
  <div class="main">
    <div class="inpBox" :class="{'inpBox_noBorder':!border}">
     <span class="Must" :class="{'Mustno':!must}">*</span>
     <div class="title">{{title}}</div>
     <div class="inpWrap">
       <input ref="input" v-if="inpBoxType=='inp'" class="inp" type="text" :placeholder="'请输入'+title" v-model="sonInpval" @input="onInput" @blur="blur">
       <div v-if="inpBoxType=='select'" class="inp" @click="select">
         <span class="selectValue_p" v-if="selectValue=='请选择'||selectValue==''">{{selectValue==''?'请选择':selectValue}}{{title}}</span>
         <span class="selectValue" v-else>{{selectValue}}</span>
       </div>
     </div>
     <div v-if="showRight">
       <img class="rightIcon" src="../assets/images/repair/rightIcon.png" alt="">
     </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'inpBox',
  props: {
    imgSrc: {
      type: String,
      default: require('../assets/images/icon_blank.png')
    },
    must:{
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: '报修类型'
    },
    showRight:{
      type: Boolean,
      default: true
    },
    inpBoxType:{
      type: String,
      default: 'inp'
    },
    keyName:{
      type: String,
      default: ''
    },
    selectValue:{
      type: String,
      default: '请选择'
    },
    border:{
      type: Boolean,
      default: true
    },
    inpval:{
      type: String,
      default: ''
    }
  },
  data () {
    return {
      sonInpval: this.inpval
    };
  },
  methods: {
    select(){
      this.$emit('select','')
    },
    blur(){
      this.$emit('blur','')
    },
    onInput(){
      this.$emit('onInput',{
        keyName:this.keyName,
        val:this.sonInpval
      })
    }
  }
};
</script>

<style lang="less" scoped>
@import "../assets/css/common.less";
.main {
  .inpBox{
    width: 100%;
    height: 100px;
    border-bottom: 2px solid #bdbdbd;
    background: #fff;
    display: flex;
    padding: 0 20px;
    box-sizing: border-box;
    align-items: center;
    .Must{
      font-size:28px;
      font-family:PingFangSC;
      font-weight:400;
      color:rgba(252,63,86,1);
      display: inline-block;
      line-height: 100px;
    }
    .Mustno{
      color: #fff;
    }
    .title{
      width: 120px;
      text-align: left;
      font-size:28px;
      font-family:PingFangSC;
      font-weight:400;
      color:rgba(51,51,51,1);
      line-height:40px;
      margin-left: 4px;

    }
    .inpWrap{
      flex: 1;
      padding-left: 60px;
      display: flex;
      .inp{
        flex: 1;
        font-size:28px;
        font-family:PingFangSC;
        font-weight:400;
        color:rgba(51,51,51,1);
      }
      .selectValue_p{
        color: #C9C9C9
      }
    }
    .rightIcon{
      width: 32px;
      height: 32px;
      margin-right: 8px;
    }
  }
  .inpBox_noBorder{
    border-bottom: none;
  }
}
</style>
